import React, {useState, useEffect} from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import Slider from 'rc-slider';
import ClickOut from 'react-click-out';
import analyseData from '../../../utils/analyseData';
import actions from '../../../redux/actions';
import style from './index.module.scss';
import {IState, Replacement} from '../../../interface';
import localesReplacement from '../../../utils/localesReplacement';
import {useDebounce} from 'use-debounce';

const cx = classnames.bind(style);

interface IProps {
  distance: string | undefined;
  distanceInMilesOrKM: number;
  isMiles: boolean | null;
  replacements: Replacement;
  setDistance: (value: string) => void;
}

//Opening hours dropdown component
export const DistanceDropdown = (props: IProps) => {
  const {distance, distanceInMilesOrKM, isMiles, replacements, setDistance} = props;
  const [visible, setVisible] = useState<boolean>(false);
  const min = 1;
  const step = 1;
  const milesOrKMs = isMiles ? 'Miles' : 'KMs';
  const [value, setValue] = useState<number>(
    distance ? _.toNumber(distance) : distanceInMilesOrKM,
  );
  const max = distanceInMilesOrKM;
  const [debounceValue] = useDebounce(value, 1000);
  const onChange = (v: number[] | number) => {
    _.isArray(v) ? setValue(v[0]) : setValue(v);
  };
  
  useEffect(() => {
      setDistance(_.toString(debounceValue));
  }, [debounceValue, distanceInMilesOrKM]);
  return (
    
    <ClickOut  className='click-out' onClickOut={() => setVisible(false)}>
      <div data-testid="dropdown" className={`dropdown ${cx('dropdown')} ${visible ? 'open' : ''}`}>
        <div className='label' onClick={() => setVisible(!visible)}>
          {localesReplacement(replacements, 'Distance')}
        </div>
        {/* Flyout for dropdown */}
        <div className={cx('flyout')}>
          <div className={cx('slider')}>
            <div
              className={cx('tooltip')}
              style={{left: analyseData.getPosition(min, max, value > 0 ? value : distanceInMilesOrKM)}}
            >
              {`${value > 0 ? value : distanceInMilesOrKM} ${milesOrKMs}`}
            </div>
            {/* Rating ranger */}
              {distanceInMilesOrKM > 0 ?
                  ( <Slider
                    range
                    min={min}
                    max={max}
                    defaultValue={distanceInMilesOrKM}
                    step={step}
                    allowCross={false}
                    onChange={(v) => onChange(v)}
                  />):<></>
              }
           
          </div>
        </div>
      </div>
    </ClickOut>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  distance: state.filter.distance,
  distanceInMilesOrKM: state.distanceInMilesOrKM,
  isMiles: state.isMiles,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setDistance: (value: string) => dispatch(actions.setDistance(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DistanceDropdown);
